








import Vue from 'vue';

export default Vue.extend({
	name: 'Mark',
	props: {
		label: String,
		color: String
	}
});
